import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const getGeneraledgerReport = catchAsync(
  async ({
    currentLang,
    companyName = '',
    from_date,
    to_date,
    account = '',
    party = [],
    cost_center = '',
    include_default_book_entries = 0,
    include_dimensions = 0,
    voucher_no = '',
  }) => {
    console.log(account, 'accountaccount');
    // const checkAcount = account !== "" ? "" : `[${account}]`;
    // console.log(checkAcount,"checkAcount");

    const { data } = await axiosInstance.get(
      // `/api/method/technoerp.services.get_report?report_name=Stock Ledger&api/method/technoerp.services.get_report?report_name=Stock Ledger&filters={"company":"${companyName}","from_date":"${from_date}","to_date":"${to_date}","valuation_field_type":"Currency","item_code": "${item_code}","voucher_no": "${voucher_no}","warehouse": "${warehouse}","stock_uom": "${stock_uom}"}&_lang=${currentLang}&ignore_prepared_report=true&_=1731064939081`
      `/api/method/technoerp.services.get_report?report_name=General Ledger&filters={"company":"${companyName}","from_date":"${from_date}","to_date":"${to_date}","account":${
        account ? account : '[]'
      },"party":${
        party ? party : '[]'
      } ,"group_by":"Group by Voucher (Consolidated)","cost_center":${
        cost_center ? cost_center : '[]'
      },"include_dimensions":"${include_dimensions}","voucher_no":"${voucher_no}","include_default_book_entries":"${include_default_book_entries}"}&_lang=${currentLang}`
      // `/api/method/technoerp.services.get_report?report_name=General Ledger&filters={"company":"${companyName}","from_date":"${from_date}","to_date":"${to_date}","account":[${account}],"party":${party} ,"group_by":"Group by Voucher (Consolidated)","cost_center":[${cost_center}],"include_dimensions":"${include_dimensions}","voucher_no":"${voucher_no}","include_default_book_entries":"${include_default_book_entries}"}&_lang=${currentLang}`
    );
    return data;
  }
);
export const getAccountsReceivableSummary = catchAsync(
  async ({ currentLang, companyName = '', party = [], report_date }) => {
    const { data } = await axiosInstance.get(
      `/api/method/technoerp.services.get_report?report_name=Accounts Receivable Summary&filters={"company":"${companyName}","report_date":"${report_date}","ageing_based_on":"Due Date","range1":30,"range2":60,"range3":90,"range4":120,"party":${
        party ? party : '[]'
      }}&ignore_prepared_report=false&are_default_filters=false&_=1732881135819&_lang=${currentLang}`
    );
    return data;
  }
);
export const getAccountsPayableSummary = catchAsync(
  async ({ currentLang, companyName = '', party = [], report_date }) => {
    const { data } = await axiosInstance.get(
      `/api/method/technoerp.services.get_report?report_name=Accounts Payable Summary&filters={"company":"${companyName}","report_date":"${report_date}","ageing_based_on":"Due Date","range1":30,"range2":60,"range3":90,"range4":120,"party":${
        party ? party : '[]'
      }}&ignore_prepared_report=false&are_default_filters=false&_=1732881135830&_lang=${currentLang}`
    );
    return data;
  }
);
export const getBalanceSheet = catchAsync(
  async ({
    currentLang,
    companyName = '',
    cost_center,
    period_start_date,
    period_end_date,
    from_fiscal_year,
    to_fiscal_year,
  }) => {
    const { data } = await axiosInstance.get(
      `/api/method/technoerp.services.get_report?report_name=Balance Sheet&filters={"company":"${companyName}","filter_based_on":"Fiscal Year","period_start_date":"${period_start_date}","period_end_date":"${period_end_date}","from_fiscal_year":"${from_fiscal_year}","to_fiscal_year":"${to_fiscal_year}","periodicity":"Yearly","cost_center":${
        cost_center ? cost_center : '[]'
      },"project":[],"selected_view":"Report","accumulated_values":1,"include_default_book_entries":1}&ignore_prepared_report=false&are_default_filters=false&_=1732881135830&_lang=${currentLang}&is_tree=true&parent_field=parent_account`
    );
    return data;
  }
);
export const getConsolidatedFinancialStatement = catchAsync(
  async ({
    currentLang,
    companyName = '',
    period_start_date,
    period_end_date,
    from_fiscal_year,
    to_fiscal_year,
  }) => {
    const { data } = await axiosInstance.get(
      `/api/method/technoerp.services.get_report?report_name=Consolidated Financial Statement&filters={"company":"${companyName}","filter_based_on":"Fiscal Year","period_start_date":"${period_start_date}","period_end_date":"${period_end_date}","from_fiscal_year":"${from_fiscal_year}","to_fiscal_year":"${to_fiscal_year}","report":"Balance Sheet","presentation_currency":"SAR","include_default_book_entries":1,"show_zero_values":1}&ignore_prepared_report=false&are_default_filters=false&_=1732881135819&_lang=${currentLang}`
    );
    return data;
  }
);
